import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { tv as m } from "tailwind-variants";
import r from "./FAQ.js";
import { H as c } from "./chunks/index-UjijAVoZ.js";
const f = m({
  base: ["flex", "flex-col", "gap-5", "w-full"]
}), n = ({ children: s, className: t, heading: e, headingTag: o = "h2" }) => /* @__PURE__ */ a(e ? "section" : "div", { className: f({ class: t }), children: [
  e && /* @__PURE__ */ l(c, { className: "text-center", level: "2", tagName: o, children: e }),
  /* @__PURE__ */ l("ul", { className: "flex flex-col gap-3", children: s })
] });
n.FAQ = r;
export {
  n as default
};
